import {
  aDeleteInsightComment,
  mockDeleteInsightCommentOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockDeleteInsightCommentOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          deleteInsightComment: aDeleteInsightComment(),
        },
      });
    }
  ),
];
